import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSSmoobuStore = GenericCollectionFactory("PMS-SMOOBU-INTEGRATION", "id");